import { Alert } from "antd";
import dayjs from "dayjs";
import React from "react";

import { DD_MM_YYYY_SLASH_DATE_FORMAT, YYYY_MM_DD_DATE_FORMAT } from "@/constant";
import { Pledge } from "@/types/pledgeService";
import { amountToWords } from "@/utils/amountToWords";
import { formatAmount } from "@/utils/formatAmount";
import { toTitleCase } from "@/utils/textFormat";

import styles from "./PledgeDetails.module.css";

interface Props {
  pledge: Pledge;
  index: number;
  actionType: string;
  variant?: "default" | "customerConsent";
}
const PledgeDetails: React.FC<Props> = ({ pledge, index, actionType, variant = "default" }) => {
  const getUpperCase = (text: string): string =>
    text
      .split("_")
      .map((word) => word.toUpperCase())
      .join(" ");

  return (
    <>
      {dayjs(pledge.consent_generated_at).startOf("day").isBefore(dayjs(), "day") && (
        <Alert banner showIcon message="This consent was not completed previously in the past." />
      )}

      <div
        key={pledge?.id}
        className={`${styles.pledgeDetails} ${
          variant === "customerConsent" ? styles.customerConsent : ""
        }`}
      >
        <div className={styles.mainContainer}>
          {/* LEFT */}
          <div className={styles.leftSection}>
            <div className={styles.leftContent}>
              <div className={styles.indexCircle}>{index + 1}</div>

              <div className={styles.contentWrapper}>
                <div className={styles.ticketHeader}>
                  <p className={styles.ticketNumber}>
                    {pledge?.pledge_ticket_number ?? `Pledge Index ${index + 1}`}
                  </p>

                  <span>{`(${getUpperCase(actionType)})`}</span>
                  <div className={styles.consentGeneratedAt}>
                    Consent Generated At:{" "}
                    {dayjs(pledge.consent_generated_at).format("DD/MM/YYYY hh:mm:ss A")}
                  </div>

                  {/* <div className="flex items-center gap-2">
                        <Checkbox />
                        <span>Included for consent</span>
                      </div> */}
                </div>

                <div className={styles.amountWrapper}>
                  <p className={styles.amount}>
                    {`${pledge?.branch?.country?.toUpperCase() === "MALAYSIA" ? "RM" : "SGD"} ${formatAmount(
                      pledge?.requested_pledge_amount,
                      pledge?.branch?.country?.toUpperCase(),
                    )}`}{" "}
                    <span className={styles.orText}>OR</span>{" "}
                    <span className={styles.amountInWords}>
                      {toTitleCase(
                        amountToWords(
                          pledge?.requested_pledge_amount,
                          pledge?.branch?.country?.toUpperCase() === "MALAYSIA" ? "RM" : "SGD",
                        ),
                      )}
                    </span>
                  </p>
                </div>

                <div className={styles.articles}>
                  {pledge?.pledge_articles?.map((article, itemIndex) => (
                    <p key={itemIndex} className={styles.article}>
                      {`${article?.quantity} X ${article?.description} [${article?.article_remarks
                        ?.map((item) => item?.pledge_article_remarks?.remarks_code)
                        ?.filter(Boolean)
                        ?.join(", ")}]`}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className={styles.rightSection}>
            <div className={styles.rightContent}>
              {/* <div className=" items-center justify-between hidden lg:flex lg:justify-end gap-2 mb-3">
                    <Button className={styles.cancelBtn}>
                      <UndoOutlined /> Amend
                    </Button>
                  </div> */}

              <div className={styles.details}>
                <div className={styles.detailRow}>
                  <span>Tarikh Pajakan:</span>
                  <span className={styles.detailValue}>
                    {dayjs(pledge.pledge_date).format(DD_MM_YYYY_SLASH_DATE_FORMAT)}
                  </span>
                </div>
                <div className={styles.detailRow}>
                  <span>Tarikh Cukup Tempoh:</span>
                  <span className={styles.detailValue}>
                    {dayjs(pledge.pledge_expiry_date).format(DD_MM_YYYY_SLASH_DATE_FORMAT)}
                  </span>
                </div>

                <div className={styles.detailRow}>
                  <span>Gross Weight:</span>
                  <span className={styles.detailValue}>{pledge?.gross_weight}</span>
                </div>

                <div className={styles.detailRow}>
                  <span>
                    Bunga Sebulan (
                    {pledge?.branch?.country?.toUpperCase() === "MALAYSIA" ? "RM" : "SGD"}):
                  </span>
                  <span className={styles.detailValue}>
                    {pledge?.calculated_total_interest_amount != null
                      ? `${pledge.calculated_total_interest_amount} ${
                          pledge?.branch?.country?.toUpperCase() === "MALAYSIA" ? "RM" : "SGD"
                        }`
                      : "-"}
                  </span>
                </div>
              </div>
              {/* <div className="items-center justify-between lg:hidden">
                    <Button className={styles.cancelBtn}>
                      <UndoOutlined /> Amend
                    </Button>
                  </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PledgeDetails;
